module.exports = __webpack_public_path__ + "img/img-pet-sketch.3b21f572.jpg";